import React, { createContext, useContext, useState } from 'react';
import de from './de.json';
import en from './en.json';

const translations = { de, en };

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const stored = localStorage.getItem('lang');
    if (stored) return stored;
    return navigator.language?.startsWith('de') ? 'de' : 'en';
  });

  const setLang = (newLang) => {
    localStorage.setItem('lang', newLang);
    setLangState(newLang);
  };

  const t = (key) => {
    const keys = key.split('.');
    let result = translations[lang];
    for (const k of keys) {
      if (result == null) break;
      result = result[k];
    }
    if (result == null) {
      let fallback = translations['de'];
      for (const k of keys) {
        if (fallback == null) break;
        fallback = fallback[k];
      }
      return fallback ?? key;
    }
    return result;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useTranslation() {
  return useContext(LanguageContext);
}
